/**
 * @file 全局组件自动化注册
 * @version 1.0.0
 * @author pankzou
 * @date 2021-09-09
 * @lastModified
 * @lastModifiedDate
 */
function changStr(str){
    return str.charAt(0).toUpperCase()+str.slice(1)
}
export default {
    install(Vue) {
        const requireAll=require.context("./common",false,/\.vue$/)
        requireAll.keys().forEach((item)=>{
            Vue.component(changStr(item.replace(/\.\//,'').replace(/\.vue$/,'')),requireAll(item).default)
        })
    }
}